import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { appSections, sidebarNavigationItems } from '@/admin/navigation';
import { Sidebar, SidebarSectionName } from '@/shared/modules/layout';
import { Fragment, useMemo } from 'react';
import { getNavigationItemsForUser } from '@/admin/helpers';
import { useAccess } from '@/admin/hooks';
import { useLayoutStore } from '@/shared/modules/layout/business';
import { SidebarMenuItem } from '@/shared/modules/layout/components';
const AppSidebar = () => {
    const { userHasAccessTo } = useAccess();
    const sidebarCollapsed = useLayoutStore((state) => state.sidebarCollapsed);
    const userNavigationItems = useMemo(() => getNavigationItemsForUser(appSections, sidebarNavigationItems, userHasAccessTo), [userHasAccessTo]);
    return (_jsx(Sidebar, { children: userNavigationItems.map((navigationGroup, index) => {
            const { menuItems, groupName } = navigationGroup;
            return (_jsxs(Fragment, { children: [groupName && (_jsx(SidebarSectionName, { isFirst: index === 0, hidden: sidebarCollapsed, children: groupName })), navigationGroup.element && _jsx(navigationGroup.element, {}), menuItems.map((sectionKey) => {
                        const { id, menuItemTitle, title, linkTo, icon } = appSections[sectionKey];
                        return (_jsx(SidebarMenuItem, { linkTo: linkTo, icon: icon, title: menuItemTitle ?? title, collapsed: sidebarCollapsed }, `menuItem_${id}`));
                    })] }, `section_${groupName}_${index}`));
        }) }));
};
export { AppSidebar };
